import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "common-page"
}
const _hoisted_2 = {
  key: 0,
  class: "page-items__controls"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "common-page__clear" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "common-page__statistic"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__delimiter" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "n-page__tiles n-page__tiles-compensation-5"
}
const _hoisted_10 = {
  key: 3,
  class: "n-page__rows"
}
const _hoisted_11 = { key: 4 }
const _hoisted_12 = {
  key: 5,
  class: "page__appending-item"
}
const _hoisted_13 = { class: "page__no-data-item label-m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButtonGroup = _resolveComponent("NButtonGroup")!
  const _component_NInput = _resolveComponent("NInput")!
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_DisplayTypesButtonGroup = _resolveComponent("DisplayTypesButtonGroup")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_PageContentLayout = _resolveComponent("PageContentLayout")!

  return (_openBlock(), _createBlock(_component_PageContentLayout, { ref: "pageContent" }, {
    default: _withCtx(() => [
      (_ctx.module)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.state.filter.show && !_ctx.emptyItems)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_FilterSection, {
                    filter: _ctx.module.filter,
                    schemeSmall: _ctx.state.filter.schemeSmall,
                    schemeLarge: _ctx.state.filter.schemeLarge,
                    hasReport: _ctx.state.filter.hasReport,
                    hasFilterManager: _ctx.state.filter.hasFilterManager,
                    hasPinnedFields: _ctx.state.filter.hasPinnedFields,
                    defaultPinnedFields: _ctx.state.filter.defaultPinnedFields,
                    dataQa: _ctx.dataQaKey
                  }, {
                    small: _withCtx(() => [
                      (_ctx.state.showTabs)
                        ? (_openBlock(), _createBlock(_component_NButtonGroup, {
                            key: 0,
                            items: _ctx.state.tabs,
                            modelValue: _ctx.state.tab,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tab) = $event)),
                            "init-value-on-empty": ""
                          }, null, 8, ["items", "modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    "name-contains": _withCtx(() => [
                      _createVNode(_component_NInput, {
                        modelValue: _ctx.module.filter.current.name_contains,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.module.filter.current.name_contains) = $event)),
                        class: "common-page__search",
                        placeholder: _ctx.$t('common.search', 'f'),
                        suffixIcon: "search",
                        dataQa: _ctx.dataQaKey
                      }, null, 8, ["modelValue", "placeholder", "dataQa"])
                    ]),
                    _: 1
                  }, 8, ["filter", "schemeSmall", "schemeLarge", "hasReport", "hasFilterManager", "hasPinnedFields", "defaultPinnedFields", "dataQa"]),
                  _hoisted_3
                ]))
              : _createCommentVNode("", true),
            (!_ctx.emptyItems)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.state.showStatistics)
                    ? (_openBlock(), _createBlock(_component_Statistics, {
                        key: 0,
                        module: _ctx.module
                      }, null, 8, ["module"]))
                    : _createCommentVNode("", true),
                  _hoisted_5,
                  _createVNode(_component_SortDropdown, {
                    items: _ctx.state.sortTypes,
                    modelValue: _ctx.module.filter.current.ordering,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event)),
                    dataQa: _ctx.dataQaKey
                  }, null, 8, ["items", "modelValue", "dataQa"]),
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  (_ctx.state.addNew.show && _ctx.module.items.length)
                    ? (_openBlock(), _createBlock(_component_NButton, {
                        key: 1,
                        type: "primary",
                        icon: _ctx.state.addNew.icon,
                        disabled: !_ctx.modelAcl.add,
                        onAction: _ctx.handleCreate
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.state.addNew.label), 1)
                        ]),
                        _: 1
                      }, 8, ["icon", "disabled", "onAction"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.showAcknowledgeAll)
                    ? (_openBlock(), _createBlock(_component_NButton, {
                        key: 2,
                        type: "secondary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.acknowledge_all')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.state.playing.show)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createVNode(_component_NButton, {
                          type: "secondary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.playing.showNewItems())),
                          counter: _ctx.state.playing.newItemsCount,
                          disabled: !_ctx.state.playing.newItemsCount
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.new_items', 'f')), 1)
                          ]),
                          _: 1
                        }, 8, ["counter", "disabled"]),
                        _createVNode(_component_NButton, {
                          type: "secondary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.playing.toggle())),
                          icon: _ctx.state.playing.active ? 'pause' : 'play',
                          dataQa: `${_ctx.dataQaKey}.${_ctx.state.playing.active ? 'pause' : 'play'}`
                        }, null, 8, ["icon", "dataQa"])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.state.displayTypeShow)
                    ? (_openBlock(), _createBlock(_component_DisplayTypesButtonGroup, {
                        key: 4,
                        modelValue: _ctx.state.displayType,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.displayType) = $event)),
                        dataQa: _ctx.dataQaKey
                      }, null, 8, ["modelValue", "dataQa"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.displayType === _ctx.DisplayTypes.Short)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.state.componentForShort), {
                      key: item.key,
                      item: item,
                      selected: _ctx.getIsItemSelected(item),
                      opened: _ctx.getIsItemOpened(item),
                      pageState: _ctx.state,
                      onClick: () => _ctx.state.actionHandler('click', item)
                    }, null, 8, ["item", "selected", "opened", "pageState", "onClick"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.displayType === _ctx.DisplayTypes.Full)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.state.componentForFull), {
                      key: item.key,
                      item: item,
                      selected: _ctx.getIsItemSelected(item),
                      opened: _ctx.getIsItemOpened(item),
                      pageState: _ctx.state,
                      onClick: () => _ctx.state.actionHandler('click', item)
                    }, null, 8, ["item", "selected", "opened", "pageState", "onClick"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.displayType === _ctx.DisplayTypes.Table)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_ctx.items.length)
                    ? (_openBlock(), _createBlock(_component_NTable, {
                        key: 0,
                        columns: _ctx.state.computedTableSchema,
                        content: _ctx.items,
                        selectedItemsIds: _ctx.selectedItemIds,
                        disabledItemsIds: _ctx.disabledItemsIds,
                        "compute-row-class": _ctx.computeRowClass,
                        "onSelect:changes": _ctx.handleSelectChanges,
                        onAction: _ctx.tableActionHandler,
                        onSort: _ctx.handleTableSort
                      }, null, 8, ["columns", "content", "selectedItemsIds", "disabledItemsIds", "compute-row-class", "onSelect:changes", "onAction", "onSort"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.module.loading || _ctx.module.appending)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_NLoadingCircle)
                ]))
              : _createCommentVNode("", true),
            (_ctx.module.loaded && !_ctx.module.items.length)
              ? _renderSlot(_ctx.$slots, "items-empty", { key: 6 }, () => [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('common.no_data', 'f')), 1)
                ])
              : _createCommentVNode("", true),
            _createVNode(_component_InfiniteScroll, {
              filters: _ctx.module.filter.current,
              "next-page": _ctx.module.next_page,
              onLoadMore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.module.append()))
            }, null, 8, ["filters", "next-page"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 512))
}